import { useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import type { AppAiSettingsDto } from '../types/app-ai-settings.types';

export const useAppAiSettingsApi = () => {
    const axiosInstance = useAxiosAuth();

    return useQuery<AppAiSettingsDto>({
        queryKey: [ApiConfig.queries.superAdmin.aiSettings.queryKeys.get],
        queryFn: async () => {
            const response = await axiosInstance.get<AppAiSettingsDto>(
                ApiConfig.queries.superAdmin.aiSettings.endpoints.get,
            );
            return response.data;
        },
    });
};
